import React from 'react';
import { SubmissionExperienceModel } from '@axiom/ui-models';
import type { Experience } from '@axiom/validation';

import { Badge } from '../../element/Badge/Badge';
import { DateUtil } from '../../../utils/date-util';
import { Flashy } from '../../element/Flashy/Flashy';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Icon } from '../../element/Icon/Icon';
import { Layout } from '../../layout/Layout/Layout';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { Well } from '../../layout/Well/Well';

import { TalentExperiencesItemDescription } from './TalentExperiencesItemDescription';

export type TalentExperiencesHighlightedItemProps = {
  experience: Experience;
  name?: string;
};

export const TalentExperiencesHighlightedItem = ({
  experience,
  name = 'HIGHLIGHTED_EXPERIENCE_ITEM',
}: TalentExperiencesHighlightedItemProps) => {
  const description = new SubmissionExperienceModel(
    experience
  ).calculatedDescription();

  return (
    <Well background="light blue" name={name}>
      <Gutter vertical="16px" horizontal="16px">
        <Flashy color="dataVizBlue">
          <Layout
            direction="horizontal"
            horizontalGutter="8px"
            position="left middle"
          >
            <Icon name="star-filled" />
            {experience.isAxiom ? (
              <Badge background="orange" name="AXIOM_BADGE">
                Axiom
              </Badge>
            ) : null}
            <ParagraphHeader name="HIGHLIGHTED_EXPERIENCE_CLIENT_NAME">
              <Flashy color="textDefault">
                {experience.calculatedDisplayName}
              </Flashy>
            </ParagraphHeader>
          </Layout>
        </Flashy>
        {experience.externalOpportunityName ? (
          <Gutter top="4px">
            <Paragraph name="HIGHLIGHTED_EXPERIENCE_JOB_NAME">
              {experience.externalOpportunityName}
            </Paragraph>
          </Gutter>
        ) : null}
        <Gutter top="4px">
          <Paragraph name="HIGHLIGHTED_EXPERIENCE_DATE_RANGE">
            {DateUtil.displayDateRange(
              experience.startDate,
              experience.endDate
            )}
          </Paragraph>
        </Gutter>
        <Gutter top="4px">
          <Paragraph name="HIGHLIGHTED_EXPERIENCE_LOCATION">
            {experience.locationName}
          </Paragraph>
        </Gutter>
        {description ? (
          <Gutter top="16px">
            <TalentExperiencesItemDescription descriptionText={description} />
          </Gutter>
        ) : null}
      </Gutter>
    </Well>
  );
};
